export class CustomIdentityRequestWrapperProxy {
  grantId
  email
  provider
  name
  domain
  symboAuthToken
  mailboxId
  isStytchToken

  constructor(config) {
    // Initialize the class
    this.grantId = config.grantId
    this.email = config.email
    this.domain = config.domain // BE URL
    this.symboAuthToken = config.symboAuthToken
    this.isStytchToken = config.isStytchToken
    this.provider = config.provider
    this.mailboxId = config.mailboxId
  }
  async request(args) {
    try {
      const response = await fetch(`${this.domain}/mailboxes/${this.mailboxId}/scheduler/api`, {
        method: 'POST',
        body: JSON.stringify({
          payload: args.body,
          path: args.path,
          grantId: this.grantId,
          method: args.method,
        }),
        headers: {
          ...args.headers,
          ...(this.isStytchToken
            ? { 'X-Stytch-JWT': this.symboAuthToken }
            : { Authorization: `Bearer ${this.symboAuthToken}` }),
          'Content-Type': 'application/json',
        },
      })

      // Check if the response is not okay (e.g., 404, 500)
      if (!response.ok) {
        console.error(`Error: ${response.status} ${response.statusText}`)
        return {
          error: `Error: ${response.status} ${response.statusText}`,
        }
      }

      // Parse the response
      const data = await response.json()
      return [data, null]
    } catch (error) {
      console.error('Fetch error:', error)
      return { error: 'Error' }
    }
  }

  /**
   * This method returns the current user's information.
   */

  async currentUser() {
    // IMPLEMENT: Get the logged in user's ID token and return the user information. For example,
    return {
      id: this.grantId,
      email: this.email,
      provider: this.provider,
    }
  }

  /**
   * This method sets the default authentication arguments to use when authenticating the user.
   */
  async setDefaultAuthArgs(authArgs) {
    // Set the default authentication arguments
    return authArgs
  }

  /**
   * This method returns the URL to redirect the user to for authentication.
   */
  async authenticationUrl() {
    // IMPLEMENT: Return the URL to redirect the user to for authentication. For example,
    return `${window.location.origin}/editor`
  }
}
